<template>
  <!--VMI小程序图片上传事例-->
  <div class="h-help" :class="from==='pc'?'help-pc':'help-app'">
    <div v-if="!type">
      <template v-for="value in map">
        <div class="help-title">
          {{ value.title }}
        </div>
        <div class="help-text">
          <ul>
            <li v-for="item in value.textList">{{ item }}</li>
          </ul>
        </div>
        <div class="help-image" :class="from==='app'?'help-image-app':''">
          <img v-monitor-src v-for="item in value.imgList" :src="item" alt="" :style="from==='app'?'':'width: calc((100% / 2) - 16px)'">
        </div>
      </template>
    </div>
    <div v-else>
      <div class="help-title">
        {{ value.title }}
      </div>
      <div class="help-text">
        <ul>
          <li v-for="item in value.textList">{{ item }}</li>
        </ul>
      </div>
      <div class="help-image" :class="from==='app'?'help-image-app':''">
        <img v-monitor-src v-for="item in value.imgList" :src="item" alt="" :style="from==='app'?'':'width: calc((100% / 3) - 16px)'">
      </div>
    </div>
  </div>
</template>

<script>
import z1 from "@/assets/img/vmi/编组4.png"
import z2 from "@/assets/img/vmi/编组5.png"
import z3 from "@/assets/img/vmi/编组6.png"
import a1 from "@/assets/img/vmi/编组2.png"
import a2 from "@/assets/img/vmi/编组3.png"

export default {
  name: "VMIImageHelp",
  data() {
    return {
      from: 'pc',
      type: null,
      map: [],
      value: {}
    }
  },
  created() {
    this.map = [
      {
        title: "不良照片要求",
        textList: ["使用检验APP现场拍摄至少三张照片。①展示部件的计量或计数型缺陷判定证据；②展示特殊类不良已执行破坏处理的证据；③展示不良物料已粘贴不良标识卡的证据；"],
        imgList: [z1, z2, z3]
      }, {
        title: "现场照片要求",
        textList: ["使用检验APP现场拍摄至少两张照片。①展示现场的待检批物料的贮存状态和周边环境；②展示现场从待检物料中随机抽取的待检样品；"],
        imgList: [a1, a2]
      }
    ]
    this.from = this.$route.query.from
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }

    if (this.type === "bl") {
      this.value = this.map[0]
    } else {
      this.value = this.map[1]
    }
    console.log(this.type)

  }
}
</script>

<style scoped lang="scss">

.h-help {
  width: 100%;
  margin: 0 auto;

  .help-title {
    background-color: #2681ff;
    color: #fff;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    height: 40px;
    margin-top: 20px;
  }

  .help-text {
    font-size: 16px;
  }

  .help-image {
    display: flex;

    img {
      margin: 8px;
      display: flex;
      flex: 1;
    }
  }

  .help-image-app {
    flex-direction: column;
  }
}

.help-app {
  //background-color: #ccc;
}

.help-pc {
  width: 1200px;
}

</style>
